import React from 'react';
import {
  ComposedChart, Area, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend
} from 'recharts';

const TooltipBox = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  const row = payload[0]?.payload || {};
  return (
    <div className="signup-pulse-tooltip">
      <div className="signup-pulse-tooltip-date">{label}</div>
      <div>New Sign Ups: <strong>{row.signups || 0}</strong></div>
      <div>Running total: <strong>{row.cumulative || 0}</strong></div>
    </div>
  );
};

const SignupTrendChart = ({ series = [], height = 320 }) => {
  const data = Array.isArray(series) ? series : [];
  const compact = data.length > 0 && data.length <= 14;

  return (
    <div className="signup-trend-chart" style={{ width: '100%', height }}>
      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart data={data} margin={{ top: 12, right: 18, left: 0, bottom: 4 }}>
          <defs>
            <linearGradient id="signupFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#1A4736" stopOpacity={0.28} />
              <stop offset="95%" stopColor="#1A4736" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
          <XAxis dataKey="label" tick={{ fill: '#64748b', fontSize: 12 }} axisLine={false} tickLine={false} />
          <YAxis
            yAxisId="daily"
            allowDecimals={false}
            tick={{ fill: '#64748b', fontSize: 12 }}
            axisLine={false}
            tickLine={false}
            width={36}
          />
          <YAxis
            yAxisId="total"
            orientation="right"
            allowDecimals={false}
            tick={{ fill: '#b0893a', fontSize: 12 }}
            axisLine={false}
            tickLine={false}
            width={36}
          />
          <Tooltip content={<TooltipBox />} />
          <Legend wrapperStyle={{ fontSize: 12, color: '#334155' }} />
          {compact ? (
            <Bar
              yAxisId="daily"
              dataKey="signups"
              name="Daily Sign Ups"
              fill="#1A4736"
              radius={[6, 6, 0, 0]}
              maxBarSize={42}
            />
          ) : (
            <Area
              yAxisId="daily"
              type="monotone"
              dataKey="signups"
              name="Daily Sign Ups"
              stroke="#1A4736"
              strokeWidth={2.5}
              fill="url(#signupFill)"
              dot={{ r: 3, fill: '#1A4736' }}
              activeDot={{ r: 5 }}
            />
          )}
          <Line
            yAxisId="total"
            type="monotone"
            dataKey="cumulative"
            name="Running total"
            stroke="#C4A35A"
            strokeWidth={2.2}
            dot={false}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SignupTrendChart;
